<div class="header">
  <ng-content select="[header]"></ng-content>
</div>
<ng-content></ng-content>
